import { create_scroll_spy } from '../_partials/_scroll-spy.js';
import { init_search_jobs } from '../_partials/_search-jobs.js';
import { init_sticky_height } from '../_partials/_sticky-height.js';

// Covers every `[data-hub-search]` trigger (the nav and CTA buttons).
init_search_jobs();

init_sticky_height(document.getElementById(`js-hub-nav`));

(function () {
	const links_el = document.getElementById(`js-hub-nav-links`);
	if (!links_el) {
		return;
	}

	create_scroll_spy(links_el, {
		sticky: `.site-header, .hub-nav`,
	});
})();
